<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      Set a Participants Start Date relative to:
      <select :value="relativeTo" name="relativeTo" class="form-control" @change="handleChange">
        <option value="completion">
          Completion
        </option>
        <option value="dayOfWeek">
          Day of Week
        </option>
        <option v-if="dataAvailable" value="data">
          {{ config.sourceName }} Data
        </option>
      </select>
    </div>

    <div v-if="relativeTo == 'completion'">
      <div :class="{'has-error':errors.completionDays}">
        Upon completion of this step, schedule participant to start in
        <input :value="completionDays" class="form-control input-numeric" name="completionDays" @input="handleChange"> 
        day(s)
      </div>
    </div>

    <div v-if="relativeTo == 'dayOfWeek'">
      <div :class="{'has-error':errors.weekday}">
        Upon completion of this step, schedule participant to start on the following
        <select :value="weekday" class="form-control" name="weekday" @change="handleChange">
          <option value="" disabled>
            Select a Day
          </option>
          <option v-for="(day, key) in weekdays" :value="key">
            {{ day }}
          </option>
        </select>
      </div>

      <div v-if="weekday">
        If this event is completed on a {{ weekdays[weekday] }}, start the participant
        <select :value="dataTiming" name="dataTiming" class="form-control" @change="handleChange">
          <option value="after" selected>
            The following week
          </option>
          <option value="immediately">
            Immediately
          </option>
        </select>
      </div>
    </div>

    <div v-if="relativeTo == 'data'">
      Schedule participant to start
      <span :class="{'has-error':errors.dataDays}">
        <input :value="dataDays" class="form-control input-numeric" name="dataDays" @input="handleChange"> 
      </span>
      day(s)
      <select :value="dataTiming" name="dataTiming" class="form-control" @change="handleChange">
        <option value="before">
          Before
        </option>
        <option value="after">
          After
        </option>
      </select>
      <span :class="{'has-error':errors.startFieldsetExportTag}">
        <select :value="startFieldsetExportTag" name="startFieldsetExportTag" class="form-control" @change="handleChange">
          <option v-for="fieldset in config.sourceFieldsets" v-if="fieldset.label != '' && isDateField(fieldset)" :value="fieldset.export_tag">{{ fieldset.label }}</option>
        </select>
      </span>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    
    props: {
      id: String,
      relativeTo: {
        default: 'completion'
      },
      completionDays: {},
      weekday: {},
      dataDays: {},
      dataTiming: {
        default: 'after'
      },
      startFieldsetExportTag: {}
    },
    data: function() {
      return {
        weekdays: {
          0: 'Sunday',
          1: 'Monday',
          2: 'Tuesday',
          3: 'Wednesday',
          4: 'Thursday',
          5: 'Friday',
          6: 'Saturday'
        }
      };
    },
    computed: {
      dataAvailable: function() {
        var allowedSourceClasses = [
          'EpicAppointmentsConnector', 
          'ClinstreamVisitsConnector', 
          'CSVConnector', 
          'QualtricsConnector',
          'surveyJSConnector'
        ];

        return this.config.sourceClass && allowedSourceClasses.indexOf(this.config.sourceClass) != -1;
      }
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (this.relativeTo == 'completion') {
          if (!this.isInteger(this.completionDays)) {
            this.errors.completionDays = "Please enter a number of days to start the participant in.";
          }
        } else if (this.relativeTo == 'dayOfWeek') {
          if (!this.weekday) {
            this.errors.weekday = "Please select a day for participants to start.";
          }
        } else if (this.relativeTo == 'data') {
          if (!this.isInteger(this.dataDays)) {
            this.errors.dataDays = "Please enter a number of days.";
          }
          if (!this.startFieldsetExportTag) {
            this.errors.startFieldsetExportTag = "Please select a field.";
          }

        }
        
        return Object.keys(this.errors).length === 0;
      },
      isDateField: function(fieldset) {
        return fieldset.type == 'date' || fieldset.type == 'datetime';
      }
    }
  };
</script>